import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';

// Note, these are not treated as real Redux actions. More info in inpageActionTypes.js

export const logInpageSeleniumEvent = (event, data) => {
  return {
    type: actionTypes.LOG_SELENIUM_EVENT,
    event,
    data
  };
};